import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "../../../constants/Settings";
import { PayrollTrial } from "@/model/PayrollTrial";
import { datePickerLang } from "@/constants/globalConstants";
import PayGroupService from "@/service/PayGroupService";
import ArrayHelper from "../../../common/helper/ArrayHelper";
import PayrollTrialService from "../../../service/PayrollTrialService";
import PayTrialApproval from "./PayTrialApproval/PayTrialApproval.vue";
import SpecPayApproval from "./SpecPayApproval/SpecPayApproval.vue";
import FinalApproval from "./FinalApproval/FinalApproval.vue";
export default {
    components: {
        DatePicker,
        moment,
        PayTrialApproval,
        SpecPayApproval,
        FinalApproval,
    },
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    data() {
        return {
            menuRights: { allRights: {}, rightsForThisMenu: {} },
            menuId: Settings.MenuID.PayrollApproval,
            Settings: Settings,
            dictEnum: dictEnum,
            lang: datePickerLang,
            tab: "PayTrial",
            MenuList: []
        };
    },

    mounted() {
        this.assignRights();

        this.MenuList = [
            {
                id: "PayTrial",
                text: t.t(dictEnum.LBL_PayrollTrial),
                show: this.hasRight(Settings.Permission.Read, Settings.MenuID.PayrollTrial)
            },
            {
                id: "SpecPay",
                text: t.t(dictEnum.LBL_SpecialPayment),
                show: this.hasRight(Settings.Permission.Read, Settings.MenuID.SpecialPayment)
            },
            {
                id: "Final",
                text: t.t(dictEnum.LBL_FinalPayment),
                show: this.hasRight(Settings.Permission.Read, Settings.MenuID.FinalPayment)
            }
        ];
        this.tab = this.MenuList.filter((x) => x.show)[0].id
    },

    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },
        changeTab(id) {
            this.tab = id
        }
    },
};


// WEBPACK FOOTER //
// ./src/components/100000-Payroll/104000-PayrollApproval/104000-PayrollApproval.js